import { IProjectCostCenter } from '../../interfaces/iproject-cost-center';
import { CostCenter } from '../cost-center';
import { Project } from '../project';

export class ProjectCostCenterBase {
  ProjectCostCenterId: number;
  ProjectId: number;
  CostCenterId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  CostCenter?: CostCenter;
  Project?: Project;

  constructor(item?: IProjectCostCenter) {
    if (item) {

      this.ProjectCostCenterId = item.ProjectCostCenterId;
      this.ProjectId = item.ProjectId;
      this.CostCenterId = item.CostCenterId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.CostCenter = new CostCenter(item.CostCenter);
      this.Project = new Project(item.Project);
    }
  }
}